import {FC} from 'react';
import SvgIcon, {SvgIconProps} from '@mui/material/SvgIcon';

export const OneNoteIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        arial-label='OneNote File'
        role='img'
        viewBox='-3 -2 22 24'
    >
        <path
            d='M2 0C.9 0 .01.9.01 2L0 18c0 1.1.89 2 1.99 2H14c1.1 0 2-.9 2-2V6l-6-6H2zm7 7V1.5L14.5 7H9zM3.535 9.29h2.34l4.47 7.185h.03V9.29h2.205V20h-2.355L5.77 12.83h-.03V20H3.535V9.29z'
            fillRule='nonzero'
        />
    </SvgIcon>
);
